import { useState } from "react";
import { FileText, Mail } from "lucide-react";
import { errMsg } from "@/lib/ops";

// Printable progress report + email to the guardian on file (one athlete, or every athlete in a session).
export default function ReportButtons({ ops, admin, pid, discipline, sessionId }) {
  const [msg, setMsg] = useState("");
  const email = async () => {
    if (!window.confirm(sessionId ? "Email a progress report to every family in this session?" : "Email this athlete's progress report to the guardian on file?")) return;
    setMsg("Sending…");
    try {
      const r = await ops.post("/admin/reports/email", sessionId ? { session_id: sessionId } : { player_ids: [pid], discipline });
      const miss = r.results.filter((x) => !x.sent);
      setMsg(`Sent ${r.sent} report${r.sent === 1 ? "" : "s"}.${miss.length ? ` Not sent: ${miss.map((x) => `${x.name} (${x.reason})`).join(", ")}` : ""}`);
    } catch (e) { setMsg(errMsg(e)); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2">
      {pid && <button data-testid="report-print" onClick={() => ops.openHtml(`/admin/reports/player/${pid}`, { discipline })} className="inline-flex items-center gap-1.5 rounded-full border border-slate-300 px-4 py-2 text-sm font-bold text-[#0B0F19]"><FileText size={14} /> Progress report</button>}
      {admin && <button data-testid={sessionId ? "report-email-session" : "report-email"} onClick={email} className="inline-flex items-center gap-1.5 rounded-full bg-[#0B0F19] px-4 py-2 text-sm font-bold text-white"><Mail size={14} /> {sessionId ? "Email reports to families" : "Email to parent"}</button>}
      {msg && <span data-testid="report-msg" className="text-xs font-semibold text-slate-600">{msg}</span>}
    </div>
  );
}
